import axios from 'axios';

import { 
    HEADERS_TOKEN,
    ORGANISMOS_PUBLICOS
} from 'constants/routes/endpoints';

//export const getCatalogoOrganismosPublicos = () => {
export const getOrganismosPublicos = () => {

    return new Promise((resolve, reject) => {
        return axios({
            url: ORGANISMOS_PUBLICOS,
            method: 'GET',
            headers: HEADERS_TOKEN,
        })
            .then(response => response)
            .then(json => {
                return resolve({ data: json.data });

                
            })
            .catch(err => {
            if (err.response.status === 401 || err.response.status === 500){
                window.location.href = `/login`;
            }
            });
    });
};

